import SimpleBar from 'simplebar';
import { Modal } from "bootstrap";
const colorMap = {
    "rsa": '#EF7D00',
    "sanita": '#00AAC3',
    "appartamenti": '#FFCC00',
    "cure": '#91BE1E'
}
let activefilters = {};
let toggleArray  = [];
let infoWindows = [];

const initMapFilter = ( $el ) => {
    let activeregion = '';
    // Find marker elements within map.
    let $markers = $el.querySelectorAll('.marker');
    // Create gerenic map.
    let mapArgs = {
        zoom        : parseInt($el.dataset.zoom) || 7,
        mapTypeId   : google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        center: new google.maps.LatLng(45.64938233894401, 9.281023040554102),
        styles: [
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "hue": "#ff0000"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative.locality",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dedede"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e9e9e9"
                    },
                    {
                        "lightness": 17
                    }
                ]
            }
        ]
    };

    let toggleFilter = document.querySelectorAll('.mondi_toggle');
    toggleFilter.forEach( (filter) => {
        if ( toggleArray.includes(filter.dataset.filter) ) {

        }else{
            toggleArray.push(filter.dataset.filter)
        }

        filter.addEventListener('change', function(e) {
            const index = toggleArray.indexOf(false);
            if (index > -1) {
                toggleArray.splice(index, 1);
            }
            if ( e.target.checked ) {
                if ( toggleArray.includes(filter.dataset.filter) ) {

                }else{
                    toggleArray.push(filter.dataset.filter)
                }
            }else{
                const index = toggleArray.indexOf(filter.dataset.filter);
                if (index > -1) {
                    toggleArray.splice(index, 1);
                }
            }

            if (toggleArray.length === 0) {  toggleArray.push(false) }
            
            activefilters = {
                mondo: toggleArray
            }
            if ( activeregion != '' ) {
                activefilters.regione = [activeregion];
            }
            let filtered = filterPlainArray(map.markers,activefilters);
            hideAll(map);
            setMarkerVisibility(filtered);

        });
    });

    let doc_filter = document.querySelectorAll('.doc_filter');
    doc_filter.forEach( (filter) => {
        filter.addEventListener('click', function(e) {
            e.preventDefault();
            toggleMondo(filter.dataset.filter,map);
            
        });
    });

    let doc_modal = document.querySelectorAll('.doc_modal');
    doc_modal.forEach( (filter) => {
        filter.addEventListener('click', function(e) {
            e.preventDefault();
            openDocModal(filter.dataset.termid);
        });
    });

    if ( document.getElementById('map_regione')) {
        jQuery('#map_regione').select2({
            theme: "bootstrap-5",
            dropdownParent: jQuery('#map_regione').parent(),
            templateResult: formatMapResult,
            placeholder: 'Regione',
            allowClear: true,
        }).on('change', (e) => {
            activeregion = e.target.value;

            activefilters.regione = [activeregion];
            if  (activeregion == '' ) delete activefilters.regione;
            let filtered = filterPlainArray(map.markers,activefilters);
            hideAll(map);
            setMarkerVisibility(filtered);
            //toggleMondo('',map,activeregion);
            //this.press_year = e.target.value;
        });
    }

    if ( document.getElementById('map_search_structure')) {
        jQuery('#map_search_structure').select2({
            theme: "bootstrap-5",
            dropdownParent: jQuery('#map_search_structure').parent(),
            templateResult: formatMapResult,
            placeholder: 'Struttura',
            allowClear: true,
        }).on('change', (e) => {
            zoomToMarker(e.target.value,map);
            //this.press_year = e.target.value;
        });
    }

    if ( document.getElementById('scroll_doc')) {
        new SimpleBar(document.getElementById('scroll_doc'));
    }
    

    var map = new google.maps.Map( $el, mapArgs );

    // Add markers.
    map.markers = [];
    $markers.forEach( (marker) => {
        initMarkerFilter( marker, map );
    });

    // Center map based on markers.
    centerMapFilter( map );

    

    // Add a marker clusterer to manage the markers.
    //new markerClusterer( map.markers , map );
    //markerCluster( map.markers, map )
    //new markerClusterer.MarkerClusterer(map.markers,map );
    //let markers = map.markers;
    //const markerCluster = new markerClusterer.MarkerClusterer({ map, markers });
    // Return map instance.
    return map;
}

const initMarkerFilter = ( $marker, map ) => {

    // Get position from marker.
    let lat = $marker.dataset.lat;
    let lng = $marker.dataset.lng;
    let latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };
    let mondo = $marker.dataset.mondo;
    let regione = $marker.dataset.regione;
    let id = $marker.dataset.id;
    let markercolor = $marker.dataset.color;
    let filter = $marker.dataset.filter.split(',');

    let color = '';

    if ( markercolor ) {
        if (colorMap[markercolor]  ) {
            color = colorMap[markercolor];
        }else{
            color = markercolor;
        }
    }else if ( mondo ) {
        color = mondo ? colorMap[mondo] : '';
    }else{
        color = '#00AAC3';
    }

    const svgMarker = {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: color,
        fillOpacity: 1,
        strokeWeight: 0,
        scale: 5,
      };


    // Create marker instance.
    let marker = new google.maps.Marker({
        position : latLng,
        map: map,
        icon: svgMarker,
    });
    if ( regione ) {
        marker.regione = regione;
    }
    if ( id ) {
        marker.id = id;
    }

    if ( mondo ) {
        marker.mondo = mondo;
    }

    if ( filter ) {
        marker.filter = filter;
    }

    // Append to reference for later use.
    map.markers.push( marker );
    
    // If marker contains HTML, add it to an infoWindow.
    if( $marker.innerHTML != '' ){

        // Create info window.
        let infoWindow = new google.maps.InfoWindow({
            content: $marker.innerHTML
        });

        infoWindows.push(infoWindow);

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {

            //close all
            for (let i = 0; i < infoWindows.length; i++) {
                infoWindows[i].close();
            }
            infoWindow.open( map, marker );

        });

        google.maps.event.addListener(map, 'click', function() {
            infoWindow.close();
        });

    }

}

const centerMapFilter = ( map ) => {

    // Create map boundaries from all map markers.
    let bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}
const hideAll = (map) => {
    for (let i = 0; i < map.markers.length; i++) {
        let currentMarker = map.markers[i];
        currentMarker.setVisible(false);
    }
}
const toggleMondo = (mondo,map,regione) => {

    for (let i = 0; i < map.markers.length; i++) {
        let currentMarker = map.markers[i];

        if ( mondo != '' && map.markers[i].filter && map.markers[i].filter == mondo ) {
            if ( regione != '' ) {
                
                if ( map.markers[i].regione && map.markers[i].regione != regione ) {
                    if (!currentMarker.getVisible()) {
                        currentMarker.setVisible(true);
                    }else{
                        currentMarker.setVisible(false);
                    }
                }
            }else{
                if (!currentMarker.getVisible()) {
                    currentMarker.setVisible(true);
                }else{
                    currentMarker.setVisible(false);
                }
            }

        }else{
            if ( regione != '' ) {
                
                if ( map.markers[i].regione && map.markers[i].regione != regione ) {
                    if (!currentMarker.getVisible()) {
                        currentMarker.setVisible(true);
                    }else{
                        currentMarker.setVisible(false);
                    }
                }
            }
        }
    }
}

const getValue = value => (typeof value === 'string' ? value.toUpperCase() : value);

const filterPlainArray = (array, filters) => {
    const filterKeys = Object.keys(filters);

    return array.filter(item => {
      // validates all filter criteria
      return filterKeys.every(key => {
        // ignores an empty filter
        if (!filters[key].length) return true;
        return filters[key].find(filter => getValue(filter) === getValue(item[key]));
      });
    });
  }

  const setMarkerVisibility = (array) => {
    for (let i = 0; i < array.length; i++) {
        
        let currentMarker = array[i];
        currentMarker.setVisible(true);
        // if (!currentMarker.getVisible()) {
        //     currentMarker.setVisible(true);
        // }else{
        //     currentMarker.setVisible(false);
        // }
    }
  }

  const zoomToMarker = (m,map) => {
    if ( m != '' ) {
        for (let i = 0; i < map.markers.length; i++) {
            if ( map.markers[i].id == m ) {
                map.setZoom(17);
                map.panTo( map.markers[i].position);
                return;
            }else{
                map.setZoom(7);
                centerMapFilter(map);
            }
        }
    }else{
        map.setZoom(7);
        centerMapFilter(map);
    }
  }


  const openDocModal = (termid) => {
    // Apertura della modale
    var modal = document.getElementById("docModal")
    const docModal = new Modal(modal, {});
    docModal.show();

    // Seleziona tutti gli elementi con l'attributo data-filter
    const filterElements = modal.querySelectorAll('[data-filter]');

    // Itera su tutti gli elementi
    filterElements.forEach(element => {
        // Controlla se l'attributo data-filter dell'elemento corrisponde a termid
        if (element.getAttribute('data-filter') !== termid) {
            // Aggiunge la classe d-none se non corrisponde
            element.classList.add('d-none');
        } else {
            // Rimuove la classe d-none se corrisponde (per mostrare l'elemento)
            element.classList.remove('d-none');
        }
    });
}

const formatMapResult = (result) => {
    if (!result.id) {
        return result.text;
    }

    var query = jQuery('.select2-search__field').val();
    var str = result.text;

    var regex = new RegExp(query, 'i');
    var indexQuery = (str.toLowerCase()).indexOf(query.toLowerCase());

    var highlightText = str.substring(indexQuery, indexQuery + query.length);
    var newStr = str.replace(regex, '<span style="font-weight:bold">' + highlightText + '</span>')

    return jQuery('<span>' + newStr + '</span>');
}

const MapFilterMondiArray = () => {
    const mapFilter = document.querySelectorAll(".map-filtermondi");

    if ( mapFilter.length > 0 ) {
       

        mapFilter.forEach( (filtermap) => {
            initMapFilter(filtermap);
        });
    }
}

export default MapFilterMondiArray;